module.exports = __webpack_public_path__ + "img/body-part.ca98371c.svg";